/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { loadDistrictsAndSchools, loadData as loadLocaleGuideData } from '@zcode-ui/locale-guide'
import type { RouteComponentProps } from '@zcode/router-utils'
import { toSnakeCase } from '@zcode/utils'
import { getBasePath, getCurrentCity, getCurrentHood } from '../../../../inspectors/index'
import { logger } from '../../../../logger'
import { loadCityGuideCity } from '../../../../modules/currentSearch/thunks/loadCityGuideCity'
import { loadCityGuideNeighborhood } from '../../../../modules/currentSearch/thunks/loadCityGuideNeighborhood'
import { loadLocationScores } from '../../../../modules/currentSearch/thunks/loadLocationScores'
import { processPriceData } from '../../../../modules/priceData/thunks/processPriceData'
import type { Store } from '../../../../modules/types'

export const loadData = async (
  store: Pick<Store, 'dispatch' | 'getState'>,
  routeProps: RouteComponentProps
) => {
  const promises = []
  const { dispatch, getState } = store
  const state = getState()
  const city = getCurrentCity(state)
  const hood = getCurrentHood(state)
  const isHood = !!hood
  const basePath = toSnakeCase(getBasePath(routeProps.location))
  // @ts-expect-error
  promises.push(loadLocaleGuideData(store, routeProps))
  // @ts-expect-error
  promises.push(dispatch(loadDistrictsAndSchools(routeProps)))
  if (city?.path && [1, 2].includes(city?.type)) {
    promises.push(dispatch(loadLocationScores(hood ?? city)))
    if (isHood) {
      promises.push(
        dispatch(loadCityGuideNeighborhood(routeProps, hood.cityStateNameText, basePath))
      )
    } else {
      promises.push(dispatch(loadCityGuideCity(routeProps, city.path, basePath)))
    }
  }
  try {
    return await Promise.all(promises).then((response) => {
      if (response?.[0]?.data) {
        dispatch(processPriceData(response[0].data))
      }
    })
  } catch (error) {
    logger.warn('LocaleGuideLocale loadData error', error)
  }
}
